module.exports = __webpack_public_path__ + "static/media/database-table.2911bc7d.png";